(function () {
    'use strict';

    angular.module('swif.carto')
        .config(route);

    function resolveData(swifOpenbaseSiteService) {
        'ngInject';
        return swifOpenbaseSiteService.resolveData({resources: ['leaflet']});
    }

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/sites/leaflet_view', {
            templateUrl: 'partials/carto/sites_leaflet_view.html',
            controller: SitesLeafletCtrl,
            controllerAs: '$ctrl',
            reloadOnSearch: false,
            resolve: {
                data: resolveData
            }
        });
    }

    function SitesLeafletCtrl($rootScope, swifOpenbaseSiteService, data) {
        'ngInject';
        var $ctrl = this;
        $ctrl.sites = data.sites;
        $ctrl.callback = swifOpenbaseSiteService.callback;
        $ctrl.preValidate = swifOpenbaseSiteService.preValidate;
        $ctrl.onClickCurrentItem = onClickCurrentItem;

        function onClickCurrentItem(item) {
            $rootScope.$broadcast('onClickCurrentItemToOpenPopupMap', item);
        }
    }

})();
